module.exports = __webpack_public_path__ + "img/contact.8eb2f328.png";